module.exports = __webpack_public_path__ + "static/img/智能交通首页封面.9b3f4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/智能交通首页封面.png
// module id = 5/SX
// module chunks = 1